import { Directive, ViewContainerRef } from '@angular/core';


@Directive({
  selector: '[app-landing-page-host]'
})
export class LandingPageHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}

@Directive({
  selector: '[app-landing-page-title]'
})
export class LandingPageTitleDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
